import { GlobalStage, useGlobalStage } from "@/store"
import { LoadingPage, MainGame } from "./Stages"

import styles from "./index.module.scss"

export const Main = () => {
    const globalStage = useGlobalStage()

    return (
        <div className={styles.container}>
            {GlobalStage.LOADING === globalStage && <LoadingPage />}
            {GlobalStage.MAIN === globalStage && <MainGame />}
        </div>
    )
}

export default Main
